<script>
export default {
    name: "InterimBillPrint",

    data() {

        return {
            dischargeDetails: {},
            patient: {},
        };
    },

    computed: {

        totalBedCharges() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientWardCharges) return 0;

            if(!this.dischargeDetails.patientWardCharges.length) return 0;
            
            return this.dischargeDetails.patientWardCharges
                .map(wCharge => wCharge.amount ? parseFloat(wCharge.amount) : 0 )
                .reduce((sum, amt) => sum+amt);
        },

        totalDrugsAndServices() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.grandTotal ? parseFloat(drugCharges.grandTotal) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalBill() {

            return this.totalDrugsAndServices + this.totalBedCharges;
        },

        totalDeposits() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                dep.depositAmount ? parseFloat(dep.depositAmount) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalPayments() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsPayments) return 0;

            if(!this.dischargeDetails.patientsPayments.length) return 0;

            return this.dischargeDetails.patientsPayments
                .map(payment => payment.receiptAmount ? parseFloat(payment.receiptAmount) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalPaidAmt() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.paid ? parseFloat(drugCharges.paid) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalBalance() {
            return this.totalBill - this.totalPaidAmt;
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
                this.fetchDischargeDetails(), this.fetchPatient(), 
            ]).then(() => { 
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                }, 250);
            }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchDischargeDetails() {
            let url = `Inpatient/GetPatientDischargeDetails`;
                url += `?PatientID=${this.$route.query.patientID}`;
                url += `&VisitNo=${this.$route.query.visitNo}`;

            return this.$http.get(url).then(response => {
                this.dischargeDetails = response.data;
            }).catch(() => {});
        },

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patientID}`;

            return this.$http.get(url).then(response => {
              this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap text-sm mt-3">
            <div class="flex-1 p-1">
                <h5 class="font-medium">Name: {{ patient.names }}</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-medium">IP NO: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-medium">Admitted On: {{ patient.dateAdmitted | dateFormat }}</h5>
            </div>
        </div>
        <div class="w-full p-1 my-1">
            <h5 class="font-medium">Payment Mode: {{ patient.pMode }}</h5>
        </div>
        <div class="w-full p-1 my-1">
            <h5 class="font-bold">Diagnosis: {{ patient.diagnosis }}</h5>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Inpatient Charges</h5>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <thead class="text-sm">
                    <tr>
                        <th class="p-tiny">Ward</th>
                        <th class="p-tiny">Bed</th>
                        <th class="p-tiny">Bed Date In</th>
                        <th class="p-tiny">Bed Date Out</th>
                        <th class="p-tiny">Days</th>
                        <th class="p-tiny">Daily Charge</th>
                        <th class="p-tiny">Amount</th>
                    </tr>
                </thead>
                <tbody class="text-xs">
                    <tr v-for="(wardCharge,idx) in dischargeDetails.patientWardCharges" :key="idx">
                        <td class="p-tiny">{{ wardCharge.ward }}</td>
                        <td class="p-tiny">{{ wardCharge.bed }}</td>
                        <td class="p-tiny">{{ wardCharge.bedDateIn | dateFormat }}</td>
                        <td class="p-tiny">{{ wardCharge.bedDateOut | dateFormat }}</td>
                        <td class="p-tiny">{{ wardCharge.days }}</td>
                        <td class="p-tiny">{{ wardCharge.daily_Charge | numberFormat }}</td>
                        <td class="p-tiny">{{ wardCharge.amount | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Drugs & Services</h5>
        </div>
        <div class="w-full overflow-auto">
            <table class="table table-bordered table-hover">
                <thead class="text-sm">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Consultant</th>
                        <th class="p-tiny">Price</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Total</th>
                        <th class="p-tiny">paid</th>
                        <th class="p-tiny">Balance</th>
                    </tr>
                </thead>
                <tbody class="text-xs">
                    <tr v-for="(drugCharges, idx) in dischargeDetails.patientDrugsnService" :key="idx">
                        <td class="p-tiny">{{ drugCharges.txnDate | dateFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.service }}</td>
                        <td class="p-tiny">{{ drugCharges.consultant }}</td>
                        <td class="p-tiny">{{ drugCharges.charge | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.quantity }}</td>
                        <td class="p-tiny">{{ drugCharges.grandTotal | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.paid | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.balance | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Deposits Received</h5>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <thead class="text-sm">
                    <tr>
                        <th class="p-tiny">TRX Date</th>
                        <th class="p-tiny">Receipt No</th>
                        <th class="p-tiny">Type</th>
                        <th class="p-tiny">Mode</th>
                        <th class="p-tiny">Amount</th>
                        <th class="p-tiny">Allocated</th>
                        <th class="p-tiny">Un-allocated</th>
                    </tr>
                </thead>
                <tbody class="text-xs">
                    <tr v-for="(patientDeposit, idx) in dischargeDetails.patientsDeposits" :key="idx">
                        <td class="p-tiny">{{ patientDeposit.trxDate | dateFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.receiptNo }}</td>
                        <td class="p-tiny">{{ patientDeposit.paymentType }}</td>
                        <td class="p-tiny">{{ patientDeposit.mode }}</td>
                        <td class="p-tiny">{{ patientDeposit.depositAmount | numberFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.amountAllocated | numberFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Payments Received</h5>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <thead class="text-sm ">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Receipt No</th>
                        <th class="p-tiny">Mode</th>
                        <th class="p-tiny">Paid Amount</th>
                        <th class="p-tiny">Credit Amt</th>
                        <th class="p-tiny">Receipt Amt</th>
                    </tr>
                </thead>
                <tbody class="text-xs">
                    <tr v-for="(paymentReceived, idx) in dischargeDetails.patientsPayments" :key="idx">
                        <td class="p-tiny">{{ paymentReceived.date | dateFormat }}</td>
                        <td class="p-tiny">{{ paymentReceived.receipt_No }}</td>
                        <td class="p-tiny">{{ paymentReceived.mode }}</td>
                        <td class="p-tiny">{{ paymentReceived.amount | numberFormat }}</td>
                        <td class="p-tiny">{{ paymentReceived.creditAmount | numberFormat }}</td>
                        <td class="p-tiny">{{ paymentReceived.receiptAmount | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="flex flex-row content-start p-1 bg-gray-300 my-2">
                <div class="flex-1">
                    <h5 class="font-bold">Total Bill: {{ totalBill | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-bold">Payments Made: {{ totalPaidAmt | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-bold">Balance: {{ totalBalance | numberFormat }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>